import { callMsGraph } from "../graph"

export default function useAuth() {
  const RequestData = (endpoint, method = "GET", data) =>
    callMsGraph(endpoint, method, data)
  return { RequestData }
}
